import React, { useState } from "react";
import { setSelectedTip } from "store/tipMethods/slice";
import { useDispatch, useSelector } from "react-redux";
import { CartAction } from "store/actions";
import { useUserWallet } from "hooks";
import { calculateCartGrossAmount } from "utils/Utils";
import { TranslationText } from "components/TextTranslationContainer";
import { HeadingText } from "components/TextTranslationContainer";
import { CustomButton } from "components/Button";

const Tips = () => {
  const dispatch = useDispatch();
  const [customTipModal, setCustomTipModal] = useState(false);
  const [customTipValue, setCustomTipValue] = useState("");
  const { selectedTip } = useSelector((state) => state.TipMethodsReducer);
  const { cart, orderGrossAmount, itemsGrossAmount } = useSelector(
    (state) => state?.cart
  );
  const userWallet = useUserWallet();
  const { discountInfo } = useSelector((state) => state.Discounts);
  const { ordered } = useSelector((state) => state.order);

  const tips = [
    { id: 1, label: "7%", value: 0.07 },
    { id: 2, label: "10%", value: 0.1, info: "Most Common" },
    { id: 3, label: "15%", value: 0.15 },
    { id: 4, label: "Custom Tip", value: customTipValue },
  ];

  const updateCartWithTip = (tip) => {
    dispatch(
      setSelectedTip(tip ? {
        type:  tip?.type || null,
        value: tip?.value || null,
        unit: tip?.unit || null,
      }: "")
    );

    const cartTotals = calculateCartGrossAmount(
      cart,
      discountInfo,
      userWallet,
      ordered
    );

    dispatch(
      CartAction.updateCartPrice({
        originalPrice: cartTotals.itemsNetPrice,
        amountAfterDiscount: cartTotals.itemsGrossAmount,
        itemsGrossAmount: itemsGrossAmount,
        orderGrossAmount: orderGrossAmount,
        totalOrdersGrossAmount: cartTotals.totalOrdersGrossAmount,
        tipAmount: tip? cartTotals.tipAmount : null,
      })
    );
  };

  const handleTip = (tip) => {
    const isSameStandardTip =
      selectedTip?.value === tip.value &&
      tip.label !== "Custom Tip" &&
      !customTipModal;

    const isCustomTipSelected = tip.label === "Custom Tip" && customTipModal;

    if (isSameStandardTip || isCustomTipSelected) {
      handleCancelTip();
      setCustomTipValue(null);
      setCustomTipModal(false);
      return;
    }

    if (tip.label === "Custom Tip") {
      setCustomTipModal(true);
      updateCartWithTip(null);
    } else {
      setCustomTipModal(false);
      updateCartWithTip({
        type: "default",
        value: tip.value,
        unit: "percent",
      });
    }
  };

  const handleCustomTipValue = (e) => {
    const val = e.target.value;
    const parsedValue = parseFloat(val);
    const sanitizedValue = isNaN(parsedValue) ? "" : Math.max(1, parsedValue);
    setCustomTipValue(parseFloat(sanitizedValue.toFixed(2)));
  };

  const handleApplyCustomTip = () => {
    if(customTipValue){
    updateCartWithTip({
      type: "custom",
        value: parseFloat(customTipValue),
        unit: "fixed",
      });
    }
    setCustomTipModal(false);
  };

  const handleCancelTip = () => {
    updateCartWithTip(null);
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center gap-1">
        <HeadingText text="Add Tip" />
        <TranslationText
          text="(Optional)"
          className="text-dark-blue-900 text-24x font-light"
        />
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex gap-4 flex-wrap">
          {tips?.map((tip) => {
            const isSelected =
              selectedTip?.value === tip?.value ||
              (tip?.label === "Custom Tip" && customTipModal);

            return (
              <div key={tip?.id} className="flex flex-col items-center">
                <button
                  onClick={() => handleTip(tip)}
                  className={`relative h-10 rounded-8x border text-center text-13x font-light transition-colors
                  ${
                    isSelected
                      ? "bg-brand-base-primary text-white border-brand-base-primary"
                      : "bg-white text-black border-gray-300 hover:bg-brand-light-base-primary hover:text-white"
                  }
                  active:bg-brand-base-primary-dark active:border-brand-base-primary-dark active:text-white
                `}
                  style={{
                    width: "5rem",
                    padding: "0",
                    fontWeight: "light",
                  }}
                >
                  <TranslationText text={tip?.label} />
                  {isSelected && (
                    <div className="absolute -top-1 right-0 w-3 h-3 bg-brand-bgtext text-brand-base-primary rounded-full flex items-center justify-center p-1 hover:scale-125">x</div>
                  )}
                </button>
                {tip?.info && (
                  <TranslationText
                    text={tip?.info}
                    className="mt-2 font-semibold text-lg"
                  />
                )}
              </div>
            );
          })}
        </div>

        {customTipModal && (
          <div className="flex gap-4 mt-1.5 items-center">
            <input
              type="number"
              min="1"
              value={customTipValue}
              onChange={handleCustomTipValue}
              className="w-56 h-11 rounded-8x border border-gray-300 text-16x px-4"
              placeholder="10"
            />
            <CustomButton
              onClick={handleApplyCustomTip}
              outline
              className="h-11"
              style={{
                padding: "0",
                borderRadius:"8px"
              }}
            >
              <TranslationText text="Apply" />
            </CustomButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default Tips;
